import axios, { AxiosInstance, AxiosResponse } from 'axios';

import { BorrowingRequestLoadingFilters } from '@/types/filterOptions.type';
import {
  BorrowingTransactionRequestReponse,
  LinkedAssetFamilyResponse,
} from '@/types/response.type';
import { getBaseURL } from '@/utils/getBaseURL.util';

const API = ({ headers = {}, params = {} } = {}): AxiosInstance => {
  const user = JSON.parse(localStorage.getItem('user') as string) ?? {};
  const BASE_URL = getBaseURL('APP_ASSETS_V2_API');

  const instance = axios.create({
    baseURL: `${BASE_URL}/v2`,
    headers: {
      'Content-type': 'application/json',
      'Authorization': `Bearer ${user.token}`,
      ...headers,
    },
    params,
  });

  return instance;
};

const AssetServices = {
  getAssetByIdOptions: (
    params: BorrowingRequestLoadingFilters & {
      _id?: string;
    },
  ): Promise<AxiosResponse> => {
    return API({ params }).get('/assets/by-id/options');
  },

  getAsset: (params: { tag?: string }): Promise<AxiosResponse> => {
    return API({ params }).get('/assets');
  },

  getAssetAvailable: (
    params: Record<string, unknown>,
  ): Promise<AxiosResponse<BorrowingTransactionRequestReponse>> => {
    return API({ params }).get('/assets/available');
  },

  getAssetFamily: (
    ids: string,
  ): Promise<AxiosResponse<LinkedAssetFamilyResponse>> => {
    return API({ params: { id: ids } }).get('/assets/family');
  },
};

export default AssetServices;
